import type { Space } from '@cocoonspace/sdk-js/types/space'
import Image from 'next/image'

export const TransportationLine = ({
	space,
	line,
	iconSize = 20,
}: {
	space: Pick<Space, 'name' | 'zone'>
	line: {
		type: string
		lineRefs: string[]
	}
	iconSize?: number
}) => (
	<div className='flex flex-row gap-x-0.5'>
		{line.type && (
			<Image
				alt={`${line.type} ${space.zone}`}
				src={`/images/v2/stations/${space.zone}/${line.type}/${line.type}.svg`}
				height={iconSize}
				width={iconSize}
			/>
		)}

		{line.lineRefs
			.filter((lineRef) => lineRef)
			.map((lineRef, index) => (
				<Image
					key={`${line.type}-${lineRef}-${index}`}
					alt={`${space.zone} ${line.type} ${lineRef}`}
					src={`/images/v2/stations/${space.zone}/${line.type}/${lineRef}.svg`}
					height={iconSize}
					width={iconSize}
				/>
			))}
	</div>
)
